import { useCallback } from 'react';
import { walletRepository } from '../repositories/WalletRepository';
import { useWalletTransactions } from './useWalletTransactions';
import { useWallet } from './useWallet';
import { PaymentMethod, WalletType } from '../models/Transactions';
import { useTransaction } from './useTransaction';
import { Pleb } from '../models/Pleb';

export function useSpecialTransaction() {
    const { addOrReplaceTransaction } = useWalletTransactions();
    const { walletType } = useWallet();
    const { scanAndPayTransaction } = useTransaction();

    const zapMessage = useCallback(async (channelId: string, messageId: string, userId: string) => {
        try {
            if(walletType === WalletType.SPARK) {
                await scanAndPayTransaction({
                    recipient: {
                        pleb: Pleb.currentUserFromJson({_id: userId, pictures: []}),
                    },
                    amount: 1,
                    comment: '',
                    additionalInfos: {
                        channelId: channelId,
                        messageId: messageId,
                    },
                });
            } else if(walletType === WalletType.INTERNAL) {
                const transaction = await walletRepository.zapMessage(channelId, messageId, userId);
                addOrReplaceTransaction(transaction);
            }
        } catch (error) {
            console.error('Failed to zap message:', error);
            throw error;
        }
    }, [addOrReplaceTransaction]);

    const zapCall = useCallback(async (callId: string, userId: string) => {
        try {
            if(walletType === WalletType.SPARK) {
                await scanAndPayTransaction({
                    recipient: {
                        pleb: Pleb.currentUserFromJson({_id: userId, pictures: []}),
                    },
                    amount: 1,
                    comment: '',
                    additionalInfos: {
                        callId: callId,
                    },
                });
            } else if(walletType === WalletType.INTERNAL) {
                const transaction = await walletRepository.zapCall(callId, userId);
                addOrReplaceTransaction(transaction);
            }
        } catch (error) {
            console.error('Failed to zap message:', error);
            throw error;
        }
    }, [addOrReplaceTransaction]);

    return {
        zapMessage,
        zapCall,
    };
}
